export class ErrorsLang {
    public AppointmentAlreadyExists: string;
    public BarcodeUnreadable: string;
    public CantLoadCache: string;
    public HealthCardExpired: string;
    public InvalidHealthcardNumber: string;
    public InvalidLoginInformation: string;
    public MaximumNumberOfAttemptsReached: string;
    public MultiplePatientsFound: string;
    public NoAddressesFound: string;
    public NoAppointmentsFound: string;
    public NoAvailableAppointments: string;
    public NoPatientsFound: string;
    public None: string;
    public NotAbleToBookNewAppointment: string;
    public UnableToUpdateAppointmentStatus: string;
}


// WEBPACK FOOTER //
// ./src/resources/ErrorsLang.ts